/**
 * @generated SignedSource<<805b1ffd3c8bd4dd16b9f798d353ffec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiveFilter_liveFilter$data = {
  readonly placeholder: string | null | undefined;
  readonly " $fragmentType": "LiveFilter_liveFilter";
};
export type LiveFilter_liveFilter$key = {
  readonly " $data"?: LiveFilter_liveFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"LiveFilter_liveFilter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LiveFilter_liveFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    }
  ],
  "type": "LiveFilter",
  "abstractKey": null
};

(node as any).hash = "f4a47af2d8ac340ef5d7e7eecca8d45a";

export default node;
